import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"
import { Link } from "gatsby"

import { withDashboard } from "./withDashboard"
import { AccountLogout } from "../Logout/AccountLogout"
import { NavigationAccount } from "../../Navigation/Account/NavigationAccount"
import { BackgroundContainer, StyledContainer } from "../../Styled/Container"
import { RichText } from "../../RichText/RichText"
import { StyledButton } from "../../Styled/Button"
import { StyledH1, StyledP } from "../../Styled/Text"

const Bg = tw(BackgroundContainer)`pt-10`
const Container = styled(StyledContainer)`
  ${tw`relative flex flex-col max-w-xl mx-auto pt-3-2 md:pt-10 px-1-6`}
  ${({ drawer }) => (drawer ? tw`px-0` : null)}
`
const Inner = tw.div`flex flex-col md:flex-row md:min-h-30`
const HeadingSection = tw.div``
const Heading = tw.div`text-10 uppercase` // font
const Title = tw(StyledH1)`pt-1 pb-2 md:pt-3 md:pb-5`
const Description = tw.div`py-1-6 md:py-3-2 text-left`
const NavigationSection = tw.div`w-full md:w-1/3 mb-6 mr-1-2`
const ContentSection = tw.div`w-full md:w-2/3`
const Information = tw.div`pb-1`
// const InformationHeading = tw(StyledSmall)`text-14 uppercase pb-1` // font change
const InformationHeading = tw.div`text-14 uppercase pb-1`
const InformationDetails = tw.div`pb-2`
const InformationAddress = tw.div`pb-2`
const InformationContent = tw(StyledP)``
// const InformationContent = tw(StyledP)`text-14` // font change
const ButtonGroup = tw.div`flex flex-col md:flex-row`
const Button = styled(StyledButton)`
  ${tw`uppercase mr-1 mb-1-6 md:mb-0`}
  & {
    width: max-content;
  }
`
//  {tw`uppercase mr-1 mb-1-6 md:mb-0 px-2 py-1-2 text-14 md:text-18`} // font change

export const Dashboard = withDashboard(
  ({
    title,
    content,
    customer,
    loading,
    formattedAddress,
    accountDashboardUrl,
    accountDetailsUrl,
    isAccountDetails,
    children,
    drawer,
    handleClickButton,
    additionalGreeting,
  }): JSX.Element => (
    <>
      <Bg background={`light`}>
        <Container width={`full`} drawer={drawer}>
          <HeadingSection>
            <Heading className="body_small_highlight">{title}</Heading>
            {!loading && customer ? <Title as={`h2`}>{`${additionalGreeting}, ${customer?.firstName}!`}</Title> : null}
            {content ? (
              <Description>
                <RichText sanity>{content}</RichText>
              </Description>
            ) : null}
          </HeadingSection>
          <Inner>
            <NavigationSection>
              <Information>
                <InformationHeading className="body_small_highlight">{`Information`}</InformationHeading>
                <InformationDetails>
                  <InformationContent>{`${customer?.firstName ? `${customer?.firstName} ` : ""}${
                    customer?.lastName ? customer?.lastName : ""
                  }`}</InformationContent>
                  <InformationContent>{customer?.email}</InformationContent>
                </InformationDetails>
                <InformationAddress>
                  {formattedAddress?.map((part, index) => (
                    <InformationContent key={index}>{part}</InformationContent>
                  ))}
                </InformationAddress>
              </Information>
              <NavigationAccount />
              <ButtonGroup>
                {!drawer && isAccountDetails ? (
                  <Button
                    className={`secondary_button`}
                    onClick={handleClickButton}
                    as={Link}
                    to={accountDashboardUrl}
                    layout={`secondary`}
                    colour={`transparent`}
                    aria-label="Orders"
                    textsize={`md`}
                  >{`Orders`}</Button>
                ) : (
                  <Button
                    className={`secondary_button`}
                    onClick={handleClickButton}
                    as={Link}
                    to={accountDetailsUrl}
                    layout={`secondary`}
                    colour={`transparent`}
                    aria-label="Edit Account"
                    textsize={`md`}
                  >{`Edit Account`}</Button>
                )}
                <AccountLogout />
              </ButtonGroup>
            </NavigationSection>
            <ContentSection>{children}</ContentSection>
          </Inner>
        </Container>
      </Bg>
    </>
  )
)
